import React from 'react';
import Header from './components/Header';
import ArticleContent from './components/ArticleContent';
export function App() {
  return <div className="flex flex-col w-full min-h-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <ArticleContent data-id="element-2" />
    </div>;
}